import React from "react";
import {
  FormDataConsumer,
  ReferenceInput,
  AutocompleteInput,
  TextInput,
  required
} from "react-admin";


export const AgentInput = props => (
  <FormDataConsumer>
    {({ formData }) => {
      const isAgentType228 =
        Number(formData?.agentTypeId) === 228;

      return (
        <TextInput
          {...props}
          disabled={isAgentType228}
          validate={
            isAgentType228
              ? []
              : [required()]
          }
        />
      );
    }}
  </FormDataConsumer>
);